/* nr-refresh.js — homepage-refresh rails: arrow buttons scroll the rail they point at. */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-nr-rail-target]');
  if (!btn) return;
  var rail = document.getElementById(btn.getAttribute('data-nr-rail-target'));
  if (!rail) return;
  var step = rail.firstElementChild ? rail.firstElementChild.getBoundingClientRect().width + 20 : 300;
  rail.scrollBy({ left: step * Number(btn.getAttribute('data-dir')) * 2, behavior: 'smooth' });
});

/* Free-mirror picker inside the cart drawer: add the chosen mirror, then repaint the drawer from
   the section HTML Shopify returns, so the FREEMIRROR discount line shows straight away. */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-nr-gift-add]');
  if (!btn || btn.disabled) return;
  btn.disabled = true;
  var label = btn.textContent;
  btn.textContent = 'Adding…';
  fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-nr-gift-add')), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble' })
  })
    .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
    .then(function (state) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && state.sections) { drawer.renderContents(state); } else { window.location = '/cart'; }
    })
    .catch(function () { btn.disabled = false; btn.textContent = label; btn.classList.add('is-error'); });
});

/* Shipping protection switch in the cart drawer. ON by default (parity with UpCart); switching it off
   sticks for this shopper. Removed automatically if nothing else is in the cart. */
(function () {
  var busy = false;
  function off() { try { return localStorage.getItem('nr-sp-off') === '1'; } catch (e) { return false; } }
  function setOff(v) { try { v ? localStorage.setItem('nr-sp-off', '1') : localStorage.removeItem('nr-sp-off'); } catch (e) {} }
  function send(url, body) {
    busy = true;
    body.sections = 'cart-drawer,cart-icon-bubble';
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        busy = false;
        var drawer = document.querySelector('cart-drawer');
        if (drawer && state.sections) drawer.renderContents(state);
      })
      .catch(function () { busy = false; });
  }
  function add(el) { return send('/cart/add.js', { items: [{ id: Number(el.dataset.variant), quantity: 1 }] }); }
  function remove(el) { return send('/cart/change.js', { id: el.dataset.key, quantity: 0 }); }
  function reconcile() {
    if (busy) return;
    var el = document.querySelector('[data-nr-sp]');
    if (!el) return;
    var on = el.dataset.on === 'true', items = Number(el.dataset.items);
    if (on && items === 0) return remove(el);
    if (!on && items > 0 && !off()) return add(el);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nr-sp-toggle]');
    if (!btn || busy) return;
    var el = btn.closest('[data-nr-sp]');
    if (el.dataset.on === 'true') { setOff(true); remove(el); } else { setOff(false); add(el); }
  });
  function watch() {
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    new MutationObserver(function () { setTimeout(reconcile, 50); }).observe(d, { childList: true, subtree: true });
    reconcile();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();

/* PDP real-room videos: cards load + play muted only while on screen; tap = full screen with sound. */
(function () {
  var cards = document.querySelectorAll('.nr-vid__v');
  if (!cards.length) return;
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      if (en.isIntersecting) {
        if (!v.src) v.src = v.dataset.src;
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      } else { v.pause(); }
    });
  }, { rootMargin: '200px 0px', threshold: 0.4 }) : null;
  cards.forEach(function (v) { if (io) io.observe(v); });
  var box = document.querySelector('[data-nr-vbox]'), bv = box && box.querySelector('video');
  function close() { if (!box) return; bv.pause(); bv.removeAttribute('src'); bv.load(); box.hidden = true; document.body.classList.remove('overflow-hidden'); }
  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-nr-vid]');
    if (card && box) { bv.src = card.getAttribute('data-nr-vid'); box.hidden = false; document.body.classList.add('overflow-hidden'); bv.muted = false; var p = bv.play(); if (p && p.catch) p.catch(function () {}); return; }
    if (e.target.closest('[data-nr-vbox-close]') || e.target === box) close();
  });
  document.addEventListener('keyup', function (e) { if (e.key === 'Escape' && box && !box.hidden) close(); });
})();
